module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/skin-2af323b8657a3d48bc617ee51da3a555.png";